import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import FilterSection from './components/FilterSection';
import FeaturedContent from './components/FeaturedContent';
import ResourceGrid from './components/ResourceGrid';
import WebinarSection from './components/WebinarSection';
import IndustryResources from './components/IndustryResources';

const KnowledgeHubThoughtLeadershipCenter = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTopic, setSelectedTopic] = useState('all');
  const [selectedFormat, setSelectedFormat] = useState('all');
  const [selectedIndustry, setSelectedIndustry] = useState('all');

  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSearchChange = (query) => {
    setSearchQuery(query);
  };

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Knowledge Hub - Thought Leadership Center | Northstar Analytics</title>
        <meta 
          name="description" 
          content="Access expert insights, practical frameworks, and actionable resources for data strategy. Weekly thought leadership, downloadable templates, webinars, and industry-specific guidance from Northstar Analytics." 
        />
        <meta name="keywords" content="data strategy, thought leadership, analytics frameworks, data governance, compliance resources, webinars, industry insights" />
        <meta property="og:title" content="Knowledge Hub - Thought Leadership Center | Northstar Analytics" />
        <meta property="og:description" content="Navigate the complex world of data strategy with expert insights, practical frameworks, and actionable resources designed for modern data leaders." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://northstaranalytics.eu/knowledge-hub-thought-leadership-center" />
        <link rel="canonical" href="https://northstaranalytics.eu/knowledge-hub-thought-leadership-center" />
      </Helmet>

      <Header />
      
      <main className="pt-16 lg:pt-20">
        <HeroSection 
          onSearchChange={handleSearchChange}
          searchQuery={searchQuery}
        />
        
        <FilterSection
          selectedTopic={selectedTopic}
          setSelectedTopic={setSelectedTopic}
          selectedFormat={selectedFormat}
          setSelectedFormat={setSelectedFormat}
          selectedIndustry={selectedIndustry}
          setSelectedIndustry={setSelectedIndustry}
        />
        
        <FeaturedContent />
        
        <ResourceGrid
          searchQuery={searchQuery}
          selectedTopic={selectedTopic}
          selectedFormat={selectedFormat}
          selectedIndustry={selectedIndustry}
        />
        
        <WebinarSection />
        
        <IndustryResources />
      </main>
      
      <Footer />
    </div>
  );
};

export default KnowledgeHubThoughtLeadershipCenter;